export default __webpack_public_path__ + "static/media/phone.751c3b2c.png";